module.exports = __webpack_public_path__ + "img/krankenwagen.b971175b.png";